import { Interval } from '@zapier/design-system-revenue/src/types';

export const buildDowngradeWarningUrl = (
  fromPlanName: string,
  toPlanName: string,
  interval: Interval
): string =>
  encodeURI(
    `/app/billing/plans/downgrade-plan/${fromPlanName.toLocaleLowerCase()}/${toPlanName.toLocaleLowerCase()}/${interval}`
  );
